<template>
  <v-row>
    <v-row v-if="loading">
      <v-progress-circular
        :size="55"
        :width="4"
        indeterminate
        color="primary"
        class="my-12 mx-auto"
        max-width="500px"
      ></v-progress-circular>
    </v-row>
    <v-card flat max-width="500px">
      <v-card-text v-if="!loading">
        <v-row no-gutters>
          <v-col cols="12">
            <v-card elevation="0">
              <v-card-title class="subtitle-1">{{
                $t("components.details.serviceHistoryDetails.author")
              }}</v-card-title>
              <v-card-subtitle
                class="text--capitalize"
                v-if="editedItem.generated_by"
              >
                {{ editedItem.generated_by.toLowerCase() }}
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card elevation="0">
              <v-card-title class="subtitle-1">{{
                $t("components.details.serviceHistoryDetails.engineHours")
              }}</v-card-title>
              <v-card-subtitle>
                {{ editedItem.engine_hours }}
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card elevation="0">
              <v-card-title class="subtitle-1">{{
                $t("components.details.serviceHistoryDetails.completedOn")
              }}</v-card-title>
              <v-card-subtitle>
                {{
                  $moment(editedItem.completion_date)
                    .toISOString()
                    .substr(0, 10)
                }}
              </v-card-subtitle>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card elevation="0">
              <v-card-title class="subtitle-1 pb-0">{{
                $t("components.details.serviceHistoryDetails.serviceSummary")
              }}</v-card-title>
              <v-row
                no-gutter
                class="pl-3 pb-0"
                v-for="(note, index) in editedItem.notes"
                :key="index"
              >
                <v-card-subtitle
                  class="pt-0"
                  v-html="note.content"
                  style="white-space: pre-line"
                ></v-card-subtitle>
              </v-row>
              <v-row
                v-for="attachment in attachments"
                :key="attachment.uuid"
                class="mt-2 mb-12 pl-2"
              >
                <v-btn
                  text
                  class="text-none grey--text text--darken-1"
                  @click="openAttachment(attachment)"
                >
                  <v-icon class="mr-1"> mdi-file-document </v-icon>
                  <span class="truncate">{{ attachment.title }}</span>
                </v-btn>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-row>
</template>

<script>
import api from "@/utils/api.js";

export default {
  props: {
    dialog: {
      type: Object,
      default: Object,
    },
  },
  components: {},
  data: () => ({
    loading: false,
    editedItem: {},
    attachments: [],
  }),

  computed: {},

  created() {
    if (this.dialog.action === "history") {
      this.loadHistoryDetails();
    } else {
      console.error("SERVICE DETAILS: Action is not correct");
    }
  },

  methods: {
    loadHistoryDetails() {
      this.loading = true;
      if (!this.dialog.boat) {
        this.loading = false;
        console.error("SERVICE DETAILS: Action is not correct");
      }
      api
        .getServiceLogHistoryDetails(this.dialog.boat, this.dialog.details.uuid)
        .then((resp) => {
          this.editedItem = resp.data;
          this.loading = false;
          this.attachments = resp.data.notes.flatMap((item) => {
            return item.attachments;
          });
        });
    },

    openAttachment(attachment) {
      !this.getIframeStatus
        ? window.open(attachment.link, "_blank")
        : window.open(attachment.link, "_self");
    },
  },
};
</script>
<style scoped>
.truncate {
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text--capitalize {
  text-transform: capitalize;
}
</style>
